import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/shared/ui/skeleton'

/**
 * Placeholder de navegação: o que aparece enquanto o chunk da rota, o namespace
 * de i18n e o loader da rota estão em voo.
 *
 * Sem ele, `defaultPendingMs` não faz nada — o router precisa de ALGO para
 * renderizar — e a app fica parada na tela anterior, sem sinal de vida. Era a
 * causa do "travou e depois apareceu tudo de uma vez".
 *
 * Usa SÓ o namespace `common`, que é pré-carregado no boot (i18n/index.ts).
 * Puxar um namespace lazy aqui faria o próprio indicador de carregamento
 * suspender — o problema que ele existe para resolver.
 */
export function RoutePending() {
  const { t } = useTranslation('common')

  return (
    // Skeleton é aria-hidden; o status acessível mora aqui.
    <div role="status" aria-live="polite" aria-label={t('states.loading')} className="p-6">
      <div className="flex flex-col gap-4">
        {/* Cabeçalho da página */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-9 w-32" />
        </div>

        {/* Grade real de linhas — reconhecer a tela antes dos dados chegarem é
            o ponto do skeleton (ver docstring de shared/ui/skeleton.tsx). */}
        <div className="border-line flex flex-col gap-3 rounded-lg border p-4">
          {[0, 1, 2, 3, 4].map((linha) => (
            <div key={linha} className="flex items-center gap-3">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-56" />
              <Skeleton className="h-4 w-28" />
              <Skeleton className="ml-auto h-4 w-20" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
